export default customElements.define('w-icon-set', class IconSet extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-icon-set';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `<div class="${styleSelector}__icon" data-root aria-hidden="true"></div>`
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validObjectIcons () {
        return ['bin', 'bookmark-off', 'bookmark-on', 'broken-chain', 'calendar', 'camera', 'closed-envelope', 'cog', 'document', 'eye', 'eye-struck', 'floppy-disk', 'folder', 'gift', 'leaf', 'lightbulb', 'link', 'lock', 'megaphone', 'open-envelope', 'paperclip', 'parent-child', 'pdf', 'pdf-download', 'pencil', 'phone', 'piggy-bank', 'print', 'ringing-bell', 'rocket', 'rosette', 'speedometer', 'target', 'telescope', 'thumbs-up', 'thumbs-up-filled', 'timer', 'workspace' ];
    }

    static get validStateIcons () {
        return ['danger', 'danger-outlined', 'success', 'success-outlined', 'warning', 'warning-outlined'];
    }

    static get validStepIcons () {
        return ['step-1', 'step-2', 'step-3', 'step-4', 'raf-confirmed', 'raf-expired', 'raf-friend', 'raf-pending', 'raf-share', 'raf-signed-up'];
    }

    static get validSymbolIcons () {
        return ['add-person', 'arrow-left', 'arrow-right', 'camera-add', 'caret-back', 'caret-down', 'caret-down-filled', 'caret-forward', 'caret-forward-bevel', 'caret-up', 'caret-up-filled', 'center-focus', 'circle-tick', 'circle-caret-down', 'copy', 'cross', 'diamond', 'diamonds', 'download', 'facebook', 'google-plus', 'info', 'info-circle', 'info-circle-filled', 'instagram', 'linkedin', 'loop', 'menu', 'message', 'minus', 'move', 'nb', 'pause', 'percent', 'play', 'plus', 'question', 'question-circle', 'question-circle-filled', 'rect-filled', 'registered', 'reset', 'retry', 'rotate', 'share', 'sign-up', 'stop', 'tick', 'transfer-in', 'trend-down', 'trend-flat', 'trend-up', 'update', 'upload', 'user', 'video', 'x'];
    }

    static get validProductIcons() {
        return ['bank-transfer', 'cash-park-meter', 'cash-park-percentage-slider', 'cash-park-trade', 'cash-isa', 'debit-card', 'digital', 'direct-debit', 'ethical', 'gia', 'iasa', 'isa', 'jisa', 'jisa-ff', 'original', 'regulated', 'risk-level-1', 'risk-level-2', 'risk-level-3', 'risk-level-4', 'risk-level-5', 'sipp', 'variable-recurring-payment'];
    }

    static get allIcons () {
        return ['no-icon', ...this.validObjectIcons, ...this.validStateIcons, ...this.validStepIcons, ...this.validSymbolIcons, ...this.validProductIcons];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('type', {
                default: 'no-icon',
                type: wealthify.propTypes.ArrayItem(this.allIcons)
            }),
        ];
    }

    get propCallbacks() {
        return {type: (value) => {
            this.constructor.allIcons.forEach((icon) => {
                this.dom.root.classList.remove(`${this.styleSelector}__icon--${icon}`);
            });

            if (value !== 'no-icon') {
                this.classList.remove('u-display__none');
                this.dom.root.classList.add(`${this.styleSelector}__icon--${value}`);
            } else {
                this.classList.add('u-display__none');
            }
        }};
    }

});